<template>
    <div>
        <div class="tips-use-card">
            <p>请刷卡进入</p>
        </div>
<!--        <div class="content">-->
<!--            <img src="../../assets/pleaseCard.png" alt="">-->
<!--        </div>-->
        <div class="footer-box">
            <p>当前时间: </p>
            <p v-text="nowDate + ' ' + nowTime"></p>
        </div>
        <bottom-tab></bottom-tab>
    </div>
</template>

<script>
    import api from '../../http/api.js'

    export default {
        data() {
            return {
                nowDate: "", // 当前日期
                nowTime: "", // 当前时间
                rfidCode: '', // 读卡器卡号
                schoolId: window.localStorage.getItem('scId')
            }
        },
        methods: {
            pageInit() {
                let page = this;
                window.onkeydown = function (e) {
                    if (e.key == 'Enter') {
                        if(page.rfidCode.length > 4){
                            page.getUserInfo();
                        }else{
                            page.rfidCode = ''
                        }
                    } else if (
                        e.key == '0' ||
                        e.key == '1' ||
                        e.key == '2' ||
                        e.key == '3' ||
                        e.key == '4' ||
                        e.key == '5' ||
                        e.key == '6' ||
                        e.key == '7' ||
                        e.key == '8' ||
                        e.key == '9'
                    ) {
                        page.rfidCode += e.key
                    } else {
                        page.rfidCode = ''
                    }
                }
            },
            getUserInfo() {
                api.getUserByRfid(this.schoolId, this.rfidCode).then(res => {
                    if(res.data.code == 200){
                        this.rfidCode = '';
                        let userId = res.data.data[0].id;
                        this.navTo(userId)
                    }
                })
                this.rfidCode = ''
            },
            navTo(userId){
              this.$router.push({
                  path: '/peopleTemp',
                  query: {
                      id: userId
                  }
              })
            },
            // 请求时间
            currentTime() {
                setInterval(this.getDate, 500);
            },
            getDate: function () {
                var _this = this;
                let yy = new Date().getFullYear();
                let mm = new Date().getMonth() + 1;
                let dd = new Date().getDate();
                let week = new Date().getDay();
                let hh = new Date().getHours();
                let mf = new Date().getMinutes() < 10 ? "0" + new Date().getMinutes() : new Date().getMinutes();
                let ss = new Date().getSeconds() < 10 ? "0" + new Date().getSeconds() : new Date().getSeconds();
                _this.nowTime = hh + ":" + mf + ":" + ss;
                _this.nowDate = yy + "年" + mm + "月" + dd + "日";
            },
        },
        mounted() {
            this.pageInit();
            this.currentTime()
        },
        beforeDestroy() {
            window.onkeydown = null
        }
    }
</script>

<style scoped>

    .footer-box {
        width: 100%;
        position: absolute;
        bottom: 80px;
    }

    .footer-box p {
        text-align: center;
    }

    .tips-use-card {
        width: 100%;
        text-align: center;
    }

    .tips-use-card p {
        line-height: 50px;
        font-size: 40px;
        color: #606266;
    }
</style>